export default {
  to: 'נמען',
  subject: 'נושא',
  emailSentSuccessfuly: 'המייל נשלח בהצלחה לסוכן!',
  cancel: 'ביטול',
  send: 'שלח',
  sendEmail: 'שליחת מייל',
  message: 'תוכן ',
  emailSentFailed: 'התרחשה שגיאה בשליחת המייל',
  dropFiles: 'גרור קבצים לכאן',
};
